export const CONFIG = {
  // Cloudflare customer subdomain, e.g. "customer-a1b2c3d4e5.cloudflarestream.com"
  customerSubdomain: "customer-n2zxlag8kbf9xlb6.cloudflarestream.com",
  // https://customer-n2zxlag8kbf9xlb6.cloudflarestream.com/89e906ca41e51a2e1f7a2fc2f1697762/iframe
  // For public videos: the video UID.
  // For signed URLs: paste the signed token here instead — the path is identical.
  videoId: "89e906ca41e51a2e1f7a2fc2f1697762",

  // true  = live input (the player polls and picks up the broadcast automatically)
  // false = on-demand recording
  isLive: true,

  // Lesson title shown in the bar
  title: "Morning Strength",

  // The course/product these classes belong to. Shown on the standalone
  // page so a handed-off link has context instead of looking like an
  // orphaned video with no idea what it belongs to.
  courseName: "CrossFit Gymnastics LIVE",

  // The URL of THIS SAME lesson on the Kajabi site — the page that loads when
  // someone hits this course in a real browser instead of the Branded App.
  // Used to escape the app webview and as the always-visible fallback link.
  webUrl:
    "https://www.cikawellness.com/products/gymnastic-crossfit-live/categories/2160615085/posts/2199681961",

  // Poster image (optional, leave "" to skip)
  poster: "",

  // The Kajabi lesson URL for the past-recordings library — linked from the
  // "waiting for class" overlay so someone landing here between live
  // sessions has somewhere useful to go instead of a dead end.
  recordingsUrl:
    "https://www.cikawellness.com/products/gymnastic-crossfit-live/categories/2160615085/posts/2200103112",

  // How often (ms) to re-check for the stream while waiting for it to start,
  // and how often to re-check after it drops mid-session. An HLS manifest
  // fetch is tiny, so this can be aggressive without real cost.
  pollIntervalMs: 4000,

  // App-webview-to-browser handoff worker (see /handoff-worker). Used to
  // build the "Cast to TV" / "Open in Safari" link with a short-lived token
  // so the external browser doesn't need a fresh login.
  handoffWorkerUrl: "https://cika-player-handoff.tribebuilder.workers.dev",
};
